import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TeamWiseAnalyticsLanding from '../../views/ogd/PointTracker/TeamWiseAnalytics/TeamWiseAnalyticsLanding';
import ProjectAnalyticsLanding from '../../views/ogd/PointTracker/ProjectAnalytics/ProjectAnalyticsLanding';
import InduvidualAnalyticsLanding from '../../views/ogd/PointTracker/InduvidualAnalytics/InduvidualAnalyticsLanding';
import OverViewLanding from '../../views/ogd/PointTracker/OverView/OverViewLanding';
import OgaMilestoneLanding from '../../views/ogd/PointTracker/OGAMilestone/OgaMilestoneLanding';
import SogoMilestoneLanding from '../../views/ogd/PointTracker/SogoMilestone/SogoMilestoneLanding';
import FeeCollectionsLanding from '../../views/ogd/PointTracker/feeCollection/FeeCollections';
// The rebuild, its own page and its own endpoint, sharing nothing with the
// table above so the live one is never at risk while this is being written.
import OgdPointTrackerLanding from '../../views/ogd/OgdPointTracker/OgdPointTrackerLanding';
import TargetSlotFill from '../../views/ogd/OgdPointTracker/TargetSlotFill';

const PointTrackerRouter = () => {
  return (
    <Routes>
      <Route path="team-wise-analytics" element={<TeamWiseAnalyticsLanding />} />
      <Route path="project-analytics" element={<ProjectAnalyticsLanding />} />
      <Route path="individual-analytics" element={<InduvidualAnalyticsLanding />} />
      <Route path="overview" element={<OverViewLanding />} />
      <Route path="OGA-Milestone" element={<OgaMilestoneLanding />} />
      <Route path="sogo-Milestone" element={<SogoMilestoneLanding />} />
      <Route path="fee-collection" element={<FeeCollectionsLanding />} />
      <Route path="ogd-point-tracker" element={<OgdPointTrackerLanding />} />
      {/* Where a reporting head sets the monthly target and slot for their team.
          The screen itself refuses anybody with no team, and the server checks
          again on every save. */}
      <Route path="target-slot-fill" element={<TargetSlotFill />} />
    </Routes>
  );
};

export default PointTrackerRouter;
